import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ComparisonTable } from './components/ComparisonTable';
import { ProblemSection } from './components/ProblemSection';
import { ProjectCarousel } from './components/ProjectCarousel';
import { ProductPresentation } from './components/ProductPresentation';
import { BonusGrid } from './components/BonusGrid';
import { PriceBox } from './components/PriceBox';
import { FAQSection } from './components/FAQSection';
import { CommentsSection } from './components/CommentsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  return <div className="min-h-screen bg-[#09090b] font-sans selection:bg-[#00f0ff]/30 selection:text-white text-gray-100" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ComparisonTable data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <ProjectCarousel data-id="element-6" />
        <ProductPresentation data-id="element-7" />
        <BonusGrid data-id="element-8" />
        <PriceBox data-id="element-9" />
        <CommentsSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
      </main>

      <footer className="bg-[#09090b] py-12 border-t border-[#27272a] text-center" data-id="element-13">
        <div className="max-w-7xl mx-auto px-4" data-id="element-14">
          <p className="text-gray-500 text-sm mb-4" data-id="element-15">
            © {new Date().getFullYear()} Infinity Tech. Todos los derechos
            reservados.
          </p>
          <p className="text-gray-600 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-16">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <PurchaseNotifications data-id="element-17" />
    </div>;
}